export default __webpack_public_path__ + "static/media/noa-29.df15d67d.jpg";